import { ICart } from '@/src/modules/cart/ICart'

function getEmailDeliveries(cartData: ICart | undefined) {
    return cartData?.cart_contents?.deliveries.reduce(
        (acc: any, item: any) =>
            item.delivery_option?.resolved_data?.service?.service_name ===
            'Email Delivery'
                ? [...acc, item]
                : acc,
        []
    )
}

export default getEmailDeliveries
